/**
 * Thin logging chokepoint so app code doesn't pepper raw `console.*`.
 *
 * One place to later redirect to a telemetry sink or tune verbosity. Today:
 *   - `logWarn` is dev-only diagnostic noise — suppressed in production builds.
 *   - `logError` always forwards (errors are rare and worth keeping for triage).
 *
 * Prefer these over `console.warn`/`console.error` in app code. (Hot drill paths
 * like TrainingView keep their inline `console.*` for now to avoid churn.)
 */
const isDev = import.meta.env.DEV

export function logWarn(...args: unknown[]): void {
  if (isDev) console.warn(...args)
}

export function logError(...args: unknown[]): void {
  console.error(...args)
}
